interface ITime {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export const SECONDS_IN_A_DAY = 86400
export const SECONDS_IN_AN_HOUR = 3600
export const SECONDS_IN_A_MINUTE = 60
export const MILLISECONDS_IN_A_SECOND = 1000

export const dateDiffInSeconds = (startDate: Date | undefined, endDate: Date | undefined): number | undefined => {
  if (!startDate || !endDate) {
    return
  }

  return Math.abs(Math.floor((endDate.getTime() - startDate.getTime()) / MILLISECONDS_IN_A_SECOND))
}

export const countdown = (timeInSeconds: number): ITime => {
  let remainingSeconds = timeInSeconds

  const days = Math.floor(remainingSeconds / SECONDS_IN_A_DAY)
  remainingSeconds %= SECONDS_IN_A_DAY

  const hours = Math.floor(remainingSeconds / SECONDS_IN_AN_HOUR)
  remainingSeconds %= SECONDS_IN_AN_HOUR

  const minutes = Math.floor(remainingSeconds / SECONDS_IN_A_MINUTE)
  const seconds = remainingSeconds % SECONDS_IN_A_MINUTE
  return { days, hours, minutes, seconds }
}

export const isShowingTimeLeft = (secondsLeft: number | undefined): boolean | undefined => {
  if (!secondsLeft) {
    return
  }

  const { days, hours, minutes, seconds } = countdown(secondsLeft)

  if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
    return false
  }

  return days < 2
}

const pad = (number: number): number | string => (number < 10 ? `0${number}` : number)

const formatTime = ({ hours, minutes, seconds }: ITime): string => {
  const [hh, mm, ss] = [hours, minutes, seconds].map(pad)
  return `${hh}:${mm}:${ss}`
}

export const generateTimeLeft = (secondsLeft: number): string => {
  const timeLeft = countdown(secondsLeft)
  const { days, hours } = timeLeft

  if (days === 0 && hours < 12) {
    return `Ends in ${formatTime(timeLeft)}`
  }

  if (days < 1) {
    return 'Ends today'
  }

  return 'Ends soon'
}

export const secondsToTimeString = (seconds: number) => {
  const returnString = []

  const hours = Math.floor(seconds / SECONDS_IN_AN_HOUR)
  const minutes = Math.floor((seconds - hours * SECONDS_IN_AN_HOUR) / SECONDS_IN_A_MINUTE)
  const secondsLeft = seconds - hours * SECONDS_IN_AN_HOUR - minutes * SECONDS_IN_A_MINUTE

  if (hours) returnString.push(`${hours} hour${hours > 1 ? 's' : ''}`)

  if (minutes) returnString.push(`${minutes} min${minutes > 1 ? 's' : ''}`)

  if (secondsLeft) returnString.push(`${secondsLeft} sec${secondsLeft > 1 ? 's' : ''}`)

  return returnString.join(' ')
}
